/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import identity from 'lodash/identity';

import {SKIP_SYMBOL, TPayload, TUseQuery} from './useList';

type TItem = any;
type TFilters = any;

const useVirtualStorage = (payload?: any): [TItem[], (items: TItem[], index: number) => null] => {
  const [pagesState, setPagesState] = React.useState<TItem[][]>([]);

  const resetKey = JSON.stringify(payload);

  React.useLayoutEffect(() => {
    setPagesState([]);
  }, [resetKey]);

  const renderItems = React.useCallback((pageItems: TItem[], pageIndex: number) => {
    setPagesState((prev) => {
      const next = [...prev];

      next[pageIndex] = pageItems;

      return next;
    });

    return null;
  }, []);

  const allItems = React.useMemo(() => pagesState.flatMap(identity), [pagesState]);

  return [allItems, renderItems];
};

const VirtualPage = React.memo<{
  useQuery: TUseQuery<TItem, TFilters>;
  payload: TPayload;
  renderItems: (items: TItem[], index: number) => null;
  index: number;
}>(({useQuery, payload, renderItems, index}) => {
  const {data} = useQuery(payload, {
    // @ts-expect-error: ok
    skip: payload[SKIP_SYMBOL],
  });

  React.useEffect(() => {
    if (data?.content.length) {
      renderItems(data.content, index);
    }
  }, [data?.content]);

  return null;
});

export {VirtualPage, useVirtualStorage};
/* eslint-enable @typescript-eslint/no-explicit-any */
